import { FunctionComponent } from 'react';

// Contexts
import { useViewDetected } from '@Components/Utils/ViewDetected';

// Utilities
import classnames from 'classnames';

// Components
import Image from '@Components/Utils/Image';

// Styles
import styles from './AvatarStar.module.scss';

// Icons
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface AvatarStarProps {
    avatar?: string;
    average?: number;
    className?: string;
    avatarClassName?: string;
    startIconClassName?: string;
    startWrapperClassName?: string;
}

const AvatarStar: FunctionComponent<AvatarStarProps> = (props) => {
    const { deviceType } = useViewDetected();

    const className = classnames([
        styles.wrapper,
        {
            [styles.mobile]: ['mobile', 'tablet'].includes(deviceType),
        },
        props.className,
    ]);

    const avatarClass = classnames([styles.avatar, props.avatarClassName]);

    const startWrapperClass = classnames([styles.star_wrapper, props.startWrapperClassName]);

    const startClass = classnames([styles.icon_star, props.startIconClassName]);

    return (
        <div className={className}>
            <Image className={avatarClass} src={props.avatar} />
            <div className={startWrapperClass}>
                <FontAwesomeIcon className={startClass} icon={faStar} />
                {Number(props.average).toFixed(1)}
            </div>
        </div>
    );
};

AvatarStar.defaultProps = {
    average: 0,
    className: '',
    avatar: undefined,
    avatarClassName: '',
    startIconClassName: '',
    startWrapperClassName: '',
};

export default AvatarStar;
